import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Header from "../../components/NewHeader/NewHeader";
import Footer from "../../components/Footer";

import {
  MainContainer,
  HeaderWrapper,
  DropDownContainer,
  LabelRow,
  DropDownTitle,
  DropDownLightText,
  ContainerColumn,
  Chevron,
  Button,
  DropDownContent,
  SubTitle,
  ChevronLeft,
  BackContainer,
  DownloadIcon,
  UploadLabel,
  UploadContainer,
  FooterContainer,
  Column,
  Total,
  Vat,
  Price,
  StyledRow,
  TextArea,
  ItemContainer,
  ItemsColumn,
  ItemPhoto,
  ItemName,
  ItemLabel,
  ItemPrice,
  ItemColumn,
  ItemSpecifications,
  ItemProduction,
  ItemRow,
  ItemQuantity,
  Img,
  UploadLogoContainer,
  Buttons,
  Fade,
  LoaderContainer,
  Notes,
  SmallButton,
  SmallButtons,
  FadeInOut,
  StyledItemColumn,
  ButtonDisabled,
  SizeValue,
  Size,
  Color,
  Colors,
  ImageContainerRow,
  PdfContainer,
  StyledColumnDiv,
  StyledRow2,
  StyledContainer,
} from "./OpsPage.styles";

import { formatDate, priceFormatter } from "../../utils/utils";
import { useNavigate, useParams } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import MiniLoader from "../../components/MiniLoader/MiniLoader";

import {
  businessUserRoles,
  DEFAULT_LATITUDE,
  DEFAULT_LONGITUDE,
  getCurrencySymbol,
  googlePlacesKey,
  MAP_LIBRARIES,
  MAP_ZOOM_LEVEL,
  orderStates,
} from "../../utils/constants";
import {
  addDesignerDesignFile,
  addDesignerNote,
  addPackageDesignFile,
  addPackageNote,
  addProductionNote,
  addProductionPackageNote,
  getOrder,
  orderNextState,
  sendDesignsToReview,
} from "../../store/slices/marketplace/asyncThunks";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  ordersData,
  selectOrderNextStatePending,
  selectSendDesignsToReviewPending,
} from "../../store/slices/marketplace/marketplaceSlice";
import { ReactComponent as PdfIcon } from "../../assets/icons/pdf.svg";
import UploadLogo from "../../assets/images/uploadLogo.png";
import ApproveModal from "../../components/Modal/ApproveModal";
import { selectBusinessUserInfo } from "../../store/slices/businessUser/slice";

const OpsOrderDetailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id;

  const order = useSelector(ordersData);
  const businessUser = useSelector(selectBusinessUserInfo);
  const sendDesignToReviewLoader = useSelector(
    selectSendDesignsToReviewPending
  );
  const selectOrderNextStateLoader = useSelector(selectOrderNextStatePending);

  const [headerVisible, setHeaderVisible] = useState(true);
  const [lastScrollUpY, setLastScrollUpY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [firstTimeLoad, setFirstTimeLoad] = useState(true);

  const [openModalApprove, setOpenModalApprove] = useState({
    open: false,
    text: "",
    title: "",
  });
  const [show, setShow] = useState("");
  const [isVisible, setIsVisible] = useState("");

  const [location, setLocation] = useState({});
  const [uploadedImages, setUploadedImages] = useState({});
  const [notes, setNotes] = useState({});
  const [showNotes, setShowNotes] = useState({});
  const [uploadedPackageImages, setUploadedPackageImages] = useState({});
  const [packageNotes, setPackageNotes] = useState({});
  const [showPackageNotes, setShowPackageNotes] = useState({});

  const mapRef = useRef();
  const lastScrollTopRef = useRef(0);

  const containerHeight = order?.marketplaceOrderItems?.length > 2 ? 985 : 596;

  const notesTitle = () => {
    if (orderStates.mockUp === order?.state) {
      return "designers-notes";
    } else if (order?.state === orderStates.production) {
      return "production-notes";
    }
  };

  const hasProductionsRole = [
    businessUserRoles.superAdmin,
    businessUserRoles.productionAndLogistic,
    businessUserRoles.production,
  ].includes(businessUser?.role);

  const hasLogisticRole = [
    businessUserRoles.superAdmin,
    businessUserRoles.productionAndLogistic,
    businessUserRoles.logistic,
  ].includes(businessUser?.role);

  const hasDesignerRole = [
    businessUserRoles.superAdmin,
    businessUserRoles.designer,
  ].includes(businessUser?.role);

  useEffect(() => {
    let note = {};
    let showNote = {};

    order?.marketplaceOrderItems?.forEach((element) => {
      if (order?.state === orderStates.mockUp) {
        note[element.id] = element.designerNote;
        if (element.designerNote) {
          showNote[element.id] = true;
        }
      } else if (order?.state === orderStates.production) {
        note[element.id] = element.productionNote;
        if (element.productionNote) {
          showNote[element.id] = true;
        }
      }
    });
    setNotes(note);
    setShowNotes(showNote);
  }, [order]);

  useEffect(() => {
    let packageNote = {};
    let showPackageNote = {};

    if (order?.state === orderStates.mockUp && order?.packageDesignerNote) {
      packageNote[order?.id] = order?.packageDesignerNote;
      showPackageNote[order?.id] = true;
    } else if (
      order?.state === orderStates.production &&
      order?.packageDesignerNote
    ) {
      packageNote[order?.id] = order?.packageProductionNote;
      showPackageNote[order?.id] = true;
    }

    setPackageNotes(packageNote);
    setShowPackageNotes(showPackageNote);
  }, [order]);

  useEffect(() => {
    dispatch(getOrder(id))
      .unwrap()
      .then(() => {
        setFirstTimeLoad(false);
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }, [dispatch, id]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;
      const lastScrollTop = lastScrollTopRef.current;

      if (currentScrollTop === 0) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
        setScrollDirection(null);
        lastScrollTopRef.current = currentScrollTop;
        return;
      }

      if (currentScrollTop > lastScrollTop) {
        setScrollDirection("down");
        setLastScrollUpY(currentScrollTop);
      } else {
        setScrollDirection("up");
      }

      if (scrollDirection === "up" && currentScrollTop < lastScrollUpY - 350) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
      }

      if (
        scrollDirection === "down" &&
        currentScrollTop > lastScrollUpY + 350
      ) {
        setHeaderVisible(false);
      }

      lastScrollTopRef.current = currentScrollTop;
    };

    const handleScrollDebounced = () => {
      requestAnimationFrame(handleScroll);
    };

    window.addEventListener("scroll", handleScrollDebounced);

    return () => {
      window.removeEventListener("scroll", handleScrollDebounced);
    };
  }, [scrollDirection]);

  useEffect(() => {
    let timer;
    if (show) {
      timer = setTimeout(() => setIsVisible(show), 150);
    } else {
      timer = setTimeout(() => setIsVisible(""), 150);
    }

    return () => clearTimeout(timer);
  }, [show]);

  useEffect(() => {
    setLocation({ lat: order?.location?.lat, lng: order?.location?.lng });
  }, [order]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googlePlacesKey,
    libraries: MAP_LIBRARIES,
  });

  const center =
    location?.lat && location?.lng
      ? {
          lat: location.lat,
          lng: location.lng,
        }
      : {
          lat: DEFAULT_LATITUDE,
          lng: DEFAULT_LONGITUDE,
        };

  const handleMarkerDragEnd = (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results?.length > 0) {
        const address = results[0].formatted_address;
        setLocation({ lat, lng, address });
      }
    });
  };

  const handleMapClick = (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results?.length > 0) {
        const address = results[0].formatted_address;
        setLocation({ lat, lng, address });
      }
    });
  };

  const onLoad = useCallback(
    function callback(map) {
      mapRef.current = map;
      map.setCenter(center);
      map.setZoom(MAP_ZOOM_LEVEL);
    },
    [center]
  );

  const handleDownload = (url) => {
    window.open(url, "_blank");
  };

  const handleImageUpload = (id, event) => {
    const file = event.target.files[0];

    let files = [file];
    const reader = new FileReader();

    reader.onloadend = () => {
      dispatch(
        addDesignerDesignFile({
          id,
          files,
        })
      )
        .unwrap()
        .then(() => {})
        .catch((err) => toast.error(err.message));

      setUploadedImages((prev) => ({
        ...prev,
        [id]: reader.result,
      }));
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handlePackageImageUpload = (id, event) => {
    const file = event.target.files[0];
    let files = [file];
    const reader = new FileReader();

    reader.onloadend = () => {
      dispatch(
        addPackageDesignFile({
          id,
          files,
        })
      )
        .unwrap()
        .then(() => {})
        .catch((err) => toast.error(err.message));

      setUploadedPackageImages((prev) => ({
        ...prev,
        [id]: reader.result,
      }));
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleAddNote = (id, event, type) => {
    const { value } = event.target;
    if (type === "package") {
      setPackageNotes((prev) => ({
        ...prev,
        [id]: value,
      }));
    } else {
      setNotes((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const showNotesComponent = (id, type) => {
    if (type === "package") {
      setShowPackageNotes((prev) => ({
        ...prev,
        [id]: true,
      }));
    } else {
      setShowNotes((prev) => ({
        ...prev,
        [id]: true,
      }));
    }
  };

  const hideNotesComponent = (id, type) => {
    if (type === "package") {
      setShowPackageNotes((prev) => ({
        ...prev,
        [id]: false,
      }));
    } else {
      setShowNotes((prev) => ({
        ...prev,
        [id]: false,
      }));
    }
  };

  const handleSaveNote = (id, type) => {
    if (type === "package") {
      if (hasDesignerRole && order?.state === orderStates.mockUp) {
        dispatch(addPackageNote({ id, body: { note: packageNotes[id] } }))
          .unwrap()
          .then(() =>
            toast.success(t("successfully-added-package-designer-notes"))
          )
          .catch((err) => console.log(err.message));
      } else if (
        hasProductionsRole &&
        order?.state === orderStates.production
      ) {
        dispatch(
          addProductionPackageNote({ id, body: { note: packageNotes[id] } })
        )
          .unwrap()
          .then(() =>
            toast.success(t("successfully-added-package-production-notes"))
          )
          .catch((err) => console.log(err.message));
      }
    } else {
      if (hasDesignerRole && order?.state === orderStates.mockUp) {
        dispatch(addDesignerNote({ id, body: { note: notes[id] } }))
          .unwrap()
          .then(() => toast.success(t("successfully-added-designer-notes")))
          .catch((err) => console.log(err.message));
      } else if (
        hasProductionsRole &&
        order?.state === orderStates.production
      ) {
        dispatch(addProductionNote({ id, body: { note: notes[id] } }))
          .unwrap()
          .then(() => toast.success(t("successfully-added-production-notes")))
          .catch((err) => console.log(err.message));
      }
    }
  };

  const sendDesignsToReviewAction = () => {
    dispatch(sendDesignsToReview({ id }))
      .unwrap()
      .then(() => {
        toast.success(t("design-submitted-to-review"));
        navigate("/ops-portal");
      })
      .catch(() => {
        toast.error(t("error-submit-to-review"));
      });
  };

  const orderNextStateAction = (state) => {
    dispatch(orderNextState({ id }))
      .unwrap()
      .then(() => {
        if (state === "production") {
          setOpenModalApprove({
            open: true,
            text: "order-has-moved-to-logistics-team",
            title: "great-progress",
          });
        } else {
          setOpenModalApprove({
            open: true,
            text: "order-has-moved-to-customer-care-team",
            title: "great-progress",
          });
        }
      })
      .catch(() => {
        toast.error(t("error-order-next-state"));
      });
  };

  const renderButton = () => {
    if (order?.state === "mockUp") {
      return hasDesignerRole ? (
        <Button onClick={sendDesignsToReviewAction} $red>
          {t("submit-design-files")}
        </Button>
      ) : (
        <ButtonDisabled $red>{t("submit-design-files")}</ButtonDisabled>
      );
    } else if (order?.state === "production") {
      return hasProductionsRole ? (
        <Button onClick={() => orderNextStateAction("production")} $red>
          {t("ready-for-delivery")}
        </Button>
      ) : (
        <ButtonDisabled $red>{t("ready-for-delivery")}</ButtonDisabled>
      );
    } else if (order?.state === "logistics") {
      return hasLogisticRole ? (
        <Button onClick={() => orderNextStateAction("logistics")} $red>
          {t("delivered")}
        </Button>
      ) : (
        <ButtonDisabled $red>{t("delivered")}</ButtonDisabled>
      );
    }
  };
  const renderItem = (product) => {
    return (
      <ItemContainer key={product.id}>
        <ImageContainerRow>
          <ItemPhoto
            src={
              product?.marketplaceOrderItemPhotos.find(
                (photo) => photo.createdBy === "user"
              )?.photoUrl ||
              product.marketplaceItem?.marketplacePhotos[0]?.url ||
              product?.marketplaceItem?.productPhotoUrl
            }
          />
          <Colors>
            {product?.marketplaceSubcategoryItems?.map((item) => (
              <Fragment key={item.id}>
                {item.marketplaceSubcategory.value === "color" && (
                  <Color
                    style={{
                      backgroundColor: item.value,
                      border: "1.2px solid #484888",
                    }}
                  />
                )}
                {item.marketplaceSubcategory.value === "size" && (
                  <Size>
                    <SizeValue>{item.value}</SizeValue>
                  </Size>
                )}
              </Fragment>
            ))}
          </Colors>
        </ImageContainerRow>

        <ItemColumn>
          <ItemName>{product?.marketplaceItem?.name}</ItemName>
          <ItemLabel>
            {t("quantity")}:<ItemQuantity>{product?.quantity}</ItemQuantity>
          </ItemLabel>
          {!product?.buyBlank && !product?.buyPrinted ? (
            <ItemPrice>
              {!product?.productId && (
                <>
                  <ItemSpecifications>{t("production")}:</ItemSpecifications>
                  <ItemProduction>
                    {product?.productionTime === 1 ? (
                      <>
                        {product?.marketplaceItem?.productionTime}{" "}
                        {t("business-day-small")}
                      </>
                    ) : (
                      <>
                        {product?.marketplaceItem?.productionTime}{" "}
                        {t("business-days-small")}
                      </>
                    )}
                  </ItemProduction>
                </>
              )}
            </ItemPrice>
          ) : product?.buyBlank && !product?.buyPrinted ? (
            <ItemSpecifications>{t("blank-sample")}</ItemSpecifications>
          ) : !product?.buyBlank && product?.buyPrinted ? (
            <ItemSpecifications>{t("printed-sample")}</ItemSpecifications>
          ) : null}
        </ItemColumn>
        <ItemColumn>
          <ItemRow>
            <ItemLabel>{t("price")}:</ItemLabel>
            <ItemPrice>
              {priceFormatter(product?.price, true, 15)}{" "}
              {getCurrencySymbol("sar")}
            </ItemPrice>
          </ItemRow>
          <ItemRow>
            <ItemLabel>{t("total-price")}</ItemLabel>
            <ItemPrice>
              {priceFormatter(product?.price * product?.quantity, true, 15)}{" "}
              {getCurrencySymbol("sar")}
            </ItemPrice>
          </ItemRow>
        </ItemColumn>

        {(order?.state === orderStates.production ||
          order?.state === orderStates.logistics ||
          order?.state === orderStates.delivered) &&
          product?.designerNote && (
            <StyledItemColumn>
              <ItemLabel>{t("designers-notes")}:</ItemLabel>
              <ItemPrice>{product?.designerNote}</ItemPrice>
            </StyledItemColumn>
          )}
        {(order?.state === orderStates.delivered ||
          order?.state === orderStates.logistics) &&
          product?.productionNote && (
            <StyledItemColumn>
              <ItemLabel>{t("production-notes")}:</ItemLabel>
              <ItemPrice>{product?.productionNote}</ItemPrice>
            </StyledItemColumn>
          )}

        {product?.customerNote && (
          <StyledItemColumn>
            <ItemLabel>{t("customer-notes")}:</ItemLabel>
            <ItemPrice>{product?.customerNote}</ItemPrice>
          </StyledItemColumn>
        )}

        {order?.state === orderStates.mockUp && hasDesignerRole && (
          <UploadLogoContainer>
            {uploadedImages[product.id]?.includes("/pdf") ? (
              <PdfContainer>
                <PdfIcon width={60} height={60} />
              </PdfContainer>
            ) : (
              <Img src={uploadedImages[product.id] || UploadLogo} />
            )}
            <Buttons>
              <Button
                $red
                style={{ marginTop: 0 }}
                onClick={() =>
                  document.getElementById(`upload-input-${product.id}`).click()
                }
              >
                {t("upload-design-file")}
                <input
                  id={`upload-input-${product.id}`}
                  type="file"
                  accept="image/*,application/pdf"
                  style={{ display: "none" }}
                  onChange={(event) => handleImageUpload(product.id, event)}
                />
              </Button>

              <Button
                $red
                style={{ marginTop: 0 }}
                onClick={() => showNotesComponent(product.id, "product")}
              >
                {t("add-note")}
              </Button>
            </Buttons>
          </UploadLogoContainer>
        )}
        {order?.state === orderStates.production && hasProductionsRole && (
          <UploadLogoContainer>
            <Buttons>
              <Button
                $red
                style={{ marginTop: 0 }}
                onClick={() => showNotesComponent(product.id, "product")}
              >
                {t("add-note")}
              </Button>
            </Buttons>
          </UploadLogoContainer>
        )}

        {showNotes[product.id] && (
          <FadeInOut $show={showNotes[product.id]}>
            <Notes>
              <DropDownTitle>{t(notesTitle())}:</DropDownTitle>
              <TextArea
                disabled={
                  ((orderStates.production === order?.state &&
                    !hasProductionsRole) ||
                    (orderStates.mockUp === order?.state &&
                      !hasDesignerRole)) &&
                  businessUser.role !== businessUserRoles.superAdmin
                }
                onChange={(event) =>
                  handleAddNote(product.id, event, "product")
                }
                value={notes[product.id] || ""}
              />
            </Notes>
            {(orderStates.production === order?.state && hasProductionsRole) ||
              (((orderStates.mockUp === order?.state && hasDesignerRole) ||
                businessUser.role === businessUserRoles.superAdmin) && (
                <SmallButtons>
                  <SmallButton
                    $cancel
                    onClick={() => hideNotesComponent(product.id)}
                  >
                    Cancel
                  </SmallButton>
                  <SmallButton
                    onClick={() => handleSaveNote(product.id, "product")}
                  >
                    Save
                  </SmallButton>
                </SmallButtons>
              ))}
          </FadeInOut>
        )}
      </ItemContainer>
    );
  };

  return (
    <MainContainer>
      <HeaderWrapper
        style={{
          opacity: headerVisible ? 1 : 0,
          marginTop: headerVisible ? 0 : -150,
          transition: "all 0.3s ease-in-out",
        }}
      >
        <Header />
      </HeaderWrapper>
      <StyledContainer>
        {firstTimeLoad ||
        sendDesignToReviewLoader ||
        selectOrderNextStateLoader ? (
          <LoaderContainer>
            <MiniLoader />
          </LoaderContainer>
        ) : (
          <>
            <ContainerColumn>
              <BackContainer onClick={() => navigate("/ops-portal")}>
                <ChevronLeft />
                <DropDownLightText style={{ color: "black" }}>
                  {t("back")}
                </DropDownLightText>
              </BackContainer>

              <DropDownContent
                style={{
                  minHeight: show === "order-details" ? containerHeight : 72,
                }}
              >
                <DropDownContainer
                  onClick={() => {
                    window.scrollTo(0, 0);
                    if (show !== "order-details") {
                      setShow("order-details");
                    } else {
                      setShow("");
                    }
                  }}
                >
                  <LabelRow>
                    <Chevron $open={show === "order-details"} />
                    <DropDownTitle>{t("order-details")}</DropDownTitle>
                  </LabelRow>
                  <DropDownLightText>
                    {t("order-date")}: {formatDate(order.createdAt)}
                  </DropDownLightText>
                </DropDownContainer>
                {isVisible === "order-details" && (
                  <Fade $show={show === "order-details"}>
                    <ItemsColumn>
                      {order?.marketplaceOrderItems.map((product) => {
                        return renderItem(product);
                      })}
                      {order?.packageItems.map((product) => {
                        return renderItem(product);
                      })}

                      {order?.marketplaceOrderPackage && (
                        <ItemContainer>
                          <ItemPhoto
                            src={order?.marketplaceOrderPackage?.photoUrl}
                          />
                          <ItemColumn>
                            <ItemName>
                              {order?.marketplaceOrderPackage?.name}
                            </ItemName>

                            <ItemLabel>
                              {t("quantity")}:
                              <ItemQuantity>
                                {order?.packageQuantity}
                              </ItemQuantity>
                            </ItemLabel>
                          </ItemColumn>
                          <ItemColumn>
                            <ItemRow>
                              <ItemLabel>{t("price")}:</ItemLabel>
                              <ItemPrice>
                                {priceFormatter(
                                  order?.marketplaceOrderPackage?.price
                                )}{" "}
                                {getCurrencySymbol("sar")}
                              </ItemPrice>
                            </ItemRow>
                            <ItemRow>
                              <ItemLabel>{t("total-price")}</ItemLabel>
                              <ItemPrice>
                                {priceFormatter(
                                  order?.marketplaceOrderPackage?.price *
                                    order?.packageQuantity
                                )}{" "}
                                {getCurrencySymbol("sar")}
                              </ItemPrice>
                            </ItemRow>
                          </ItemColumn>

                          {(order?.state === orderStates.production ||
                            order?.state === orderStates.logistics ||
                            order?.state === orderStates.delivered) &&
                            order?.packageDesignerNote && (
                              <StyledItemColumn>
                                <ItemLabel>{t("designers-notes")}:</ItemLabel>
                                <ItemPrice>
                                  {order?.packageDesignerNote}
                                </ItemPrice>
                              </StyledItemColumn>
                            )}
                          {(order?.state === orderStates.delivered ||
                            order?.state === orderStates.logistics) &&
                            order?.packageProductionNote && (
                              <StyledItemColumn>
                                <ItemLabel>{t("production-notes")}:</ItemLabel>
                                <ItemPrice>
                                  {order?.packageProductionNote}
                                </ItemPrice>
                              </StyledItemColumn>
                            )}

                          {order?.packageCustomerNote && (
                            <StyledItemColumn>
                              <ItemLabel>{t("customer-notes")}:</ItemLabel>
                              <ItemPrice>
                                {order?.packageCustomerNote}
                              </ItemPrice>
                            </StyledItemColumn>
                          )}

                          {order?.state === orderStates.mockUp &&
                            hasDesignerRole && (
                              <UploadLogoContainer>
                                {uploadedPackageImages[order?.id]?.includes(
                                  "/pdf"
                                ) ? (
                                  <PdfContainer>
                                    <PdfIcon width={60} height={60} />
                                  </PdfContainer>
                                ) : (
                                  <Img
                                    src={
                                      uploadedPackageImages[order?.id] ||
                                      UploadLogo
                                    }
                                  />
                                )}
                                <Buttons>
                                  <Button
                                    $red
                                    style={{ marginTop: 0 }}
                                    onClick={() =>
                                      document
                                        .getElementById(
                                          `upload-input-${order?.id}`
                                        )
                                        .click()
                                    }
                                  >
                                    {t("upload-design-file")}
                                    <input
                                      id={`upload-input-${order?.id}`}
                                      type="file"
                                      accept="image/*,application/pdf"
                                      style={{ display: "none" }}
                                      onChange={(event) =>
                                        handlePackageImageUpload(
                                          order.id,
                                          event
                                        )
                                      }
                                    />
                                  </Button>

                                  <Button
                                    $red
                                    style={{ marginTop: 0 }}
                                    onClick={() =>
                                      showNotesComponent(order?.id, "package")
                                    }
                                  >
                                    {t("add-note")}
                                  </Button>
                                </Buttons>
                              </UploadLogoContainer>
                            )}
                          {order?.state === orderStates.production &&
                            hasProductionsRole && (
                              <UploadLogoContainer>
                                <Buttons>
                                  <Button
                                    $red
                                    style={{ marginTop: 0 }}
                                    onClick={() =>
                                      showNotesComponent(order?.id, "package")
                                    }
                                  >
                                    {t("add-note")}
                                  </Button>
                                </Buttons>
                              </UploadLogoContainer>
                            )}
                          {showPackageNotes[order?.id] && (
                            <FadeInOut $show={showPackageNotes[order?.id]}>
                              <Notes>
                                <DropDownTitle>
                                  {t(notesTitle())}:
                                </DropDownTitle>
                                <TextArea
                                  disabled={
                                    ((orderStates.production === order?.state &&
                                      !hasProductionsRole) ||
                                      (orderStates.mockUp === order?.state &&
                                        !hasDesignerRole)) &&
                                    businessUser.role !==
                                      businessUserRoles.superAdmin
                                  }
                                  onChange={(event) =>
                                    handleAddNote(order?.id, event, "package")
                                  }
                                  value={packageNotes[order?.id] || ""}
                                />
                              </Notes>
                              {((orderStates.production === order?.state &&
                                hasProductionsRole) ||
                                (orderStates.mockUp === order?.state &&
                                  hasDesignerRole) ||
                                businessUser.role ===
                                  businessUserRoles.superAdmin) && (
                                <SmallButtons>
                                  <SmallButton
                                    $cancel
                                    onClick={() =>
                                      hideNotesComponent(order?.id, "package")
                                    }
                                  >
                                    Cancel
                                  </SmallButton>
                                  <SmallButton
                                    onClick={() =>
                                      handleSaveNote(order?.id, "package")
                                    }
                                  >
                                    Save
                                  </SmallButton>
                                </SmallButtons>
                              )}
                            </FadeInOut>
                          )}
                        </ItemContainer>
                      )}
                    </ItemsColumn>
                    <FooterContainer>
                      <Column>
                        <StyledRow>
                          <Total>{t("total")}</Total>
                          <Price>
                            {priceFormatter(order?.totalPrice)}{" "}
                            {getCurrencySymbol(order?.currency)}
                          </Price>
                        </StyledRow>
                        <Vat>{t("inclusive-of-vat")}</Vat>
                      </Column>
                    </FooterContainer>
                  </Fade>
                )}
              </DropDownContent>

              <DropDownContent
                style={{ minHeight: show === "customer-details" ? 596 : 72 }}
              >
                <DropDownContainer
                  onClick={() => {
                    window.scrollTo(0, 0);

                    if (show !== "customer-details") {
                      setShow("customer-details");
                    } else {
                      setShow("");
                    }
                  }}
                >
                  <LabelRow>
                    <Chevron $open={show === "customer-details"} />
                    <DropDownTitle>{t("customer-details")}</DropDownTitle>
                  </LabelRow>
                </DropDownContainer>

                {isVisible === "customer-details" && (
                  <StyledRow2 $show={show === "customer-details"}>
                    <StyledColumnDiv>
                      <SubTitle>
                        {t("company-name")}:{" "}
                        {order.customerCompanyName
                          ? order?.customerCompanyName
                          : order?.company?.name?.length > 40
                          ? order?.company?.name.slice(0, 40) + "..."
                          : order?.company?.name}
                      </SubTitle>
                      <SubTitle>
                        {t("user-name")}: {order?.fullName}
                      </SubTitle>
                      <SubTitle $noCapitalize>
                        {t("email")}:{" "}
                        {order.customerEmail
                          ? order?.customerEmail
                          : order?.businessUser?.email}
                      </SubTitle>
                      <SubTitle>
                        {t("mobile")}: {order?.mobilePhone}
                      </SubTitle>
                    </StyledColumnDiv>
                    <StyledColumnDiv>
                      <StyledRow $noSpace>
                        <SubTitle>{t("location")}:</SubTitle>
                        <SubTitle>
                          {order?.location?.name?.length > 50
                            ? order?.location?.name.slice(0, 50) + "..."
                            : order?.location?.name}
                        </SubTitle>
                      </StyledRow>

                      {isLoaded ? (
                        <GoogleMap
                          mapContainerStyle={{
                            border: "1px solid white",
                            width: "100%",
                            maxWidth: 800,
                            height: 400,
                            borderRadius: 15,
                            boxShadow:
                              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                          }}
                          onLoad={(map) => {
                            mapRef.current = map;
                            onLoad(map);
                          }}
                          zoom={MAP_ZOOM_LEVEL}
                          onClick={handleMapClick}
                        >
                          <Marker
                            position={
                              location?.lat && location?.lng
                                ? {
                                    lat: location.lat,
                                    lng: location.lng,
                                  }
                                : {
                                    lat: DEFAULT_LATITUDE,
                                    lng: DEFAULT_LONGITUDE,
                                  }
                            }
                            draggable
                            onDragEnd={handleMarkerDragEnd}
                          />
                        </GoogleMap>
                      ) : (
                        <div style={{ marginTop: 50 }}>
                          <MiniLoader />
                        </div>
                      )}
                    </StyledColumnDiv>
                  </StyledRow2>
                )}
              </DropDownContent>

              <DropDownContent
                style={{
                  minHeight: show === "customer-uploads" ? 298 : 72,
                  gap: 10,
                }}
              >
                <DropDownContainer
                  onClick={() => {
                    window.scrollTo(0, 0);
                    if (show !== "customer-uploads") {
                      setShow("customer-uploads");
                    } else {
                      setShow("");
                    }
                  }}
                >
                  <LabelRow>
                    <Chevron $open={show === "customer-uploads"} />
                    <DropDownTitle>{t("customer-uploads")}</DropDownTitle>
                  </LabelRow>
                </DropDownContainer>
                {isVisible === "customer-uploads" &&
                  order?.marketplaceOrderItems.map(
                    (o, index) =>
                      o.logoUrl && (
                        <UploadContainer
                          $show={show === "customer-uploads"}
                          key={o.id}
                        >
                          <UploadLabel>
                            Logo {index === 0 ? "" : `#${index}`}
                          </UploadLabel>
                          <DownloadIcon
                            onClick={() => handleDownload(o?.logoUrl)}
                          />
                        </UploadContainer>
                      )
                  )}
                {isVisible === "customer-uploads" &&
                  order?.marketplaceOrderItems.map((o) =>
                    o?.marketplaceOrderItemPhotos.map(
                      (photo, index) =>
                        photo?.photoUrl &&
                        (photo?.photoUrl.includes(".pdf") ? (
                          <UploadContainer
                            $show={show === "customer-uploads"}
                            key={photo.id}
                          >
                            <UploadLabel>
                              {t("pdf-file")} {index === 0 ? "" : `#${index}`}
                            </UploadLabel>
                            <DownloadIcon
                              onClick={() => handleDownload(photo?.photoUrl)}
                            />
                          </UploadContainer>
                        ) : (
                          <UploadContainer
                            $show={show === "customer-uploads"}
                            key={photo.id}
                          >
                            <UploadLabel>
                              {t("product-logo")}{" "}
                              {index === 0 ? "" : `#${index}`}
                            </UploadLabel>
                            <DownloadIcon
                              onClick={() => handleDownload(photo?.photoUrl)}
                            />
                          </UploadContainer>
                        ))
                    )
                  )}
                {isVisible === "customer-uploads" && order?.packageLogoUrl && (
                  <UploadContainer $show={show === "customer-uploads"}>
                    <UploadLabel>{t("package-logo")}</UploadLabel>
                    <DownloadIcon
                      onClick={() => handleDownload(order?.packageLogoUrl)}
                    />
                  </UploadContainer>
                )}
              </DropDownContent>

              {renderButton()}
            </ContainerColumn>
          </>
        )}
      </StyledContainer>
      <Footer />
      <ApproveModal
        open={openModalApprove.open}
        width={"30rem"}
        height={"30rem"}
        text={openModalApprove.text}
        title={openModalApprove.title}
        onClose={() => {
          navigate("/ops-portal");
          setOpenModalApprove({
            open: false,
            text: "",
            title: "",
          });
        }}
      />
    </MainContainer>
  );
};

export default OpsOrderDetailPage;
